import { localizeWithPath } from 'vscode/vscode/vs/nls';
import { URI } from 'vscode/vscode/vs/base/common/uri';
import { EditorInput } from 'vscode/vscode/vs/workbench/common/editor/editorInput';
import { Codicon } from 'vscode/vscode/vs/base/common/codicons';
import { registerIcon } from 'vscode/vscode/vs/platform/theme/common/iconRegistry';

const _moduleId = "vs/workbench/contrib/extensions/common/runtimeExtensionsInput";
const RuntimeExtensionsEditorIcon = registerIcon('runtime-extensions-editor-label-icon', Codicon.extensions, ( localizeWithPath(_moduleId, 0, 'Icon of the runtime extensions editor label.')));
class RuntimeExtensionsInput extends EditorInput {
    constructor() {
        super(...arguments);
        this.resource = ( (URI.from({
            scheme: 'runtime-extensions',
            path: 'default'
        })));
    }
    static { this.ID = 'workbench.runtimeExtensions.input'; }
    get typeId() {
        return RuntimeExtensionsInput.ID;
    }
    get capabilities() {
        return 2  | 8 ;
    }
    static get instance() {
        if (!RuntimeExtensionsInput._instance || RuntimeExtensionsInput._instance.isDisposed()) {
            RuntimeExtensionsInput._instance = ( (new RuntimeExtensionsInput()));
        }
        return RuntimeExtensionsInput._instance;
    }
    getName() {
        return ( localizeWithPath(_moduleId, 1, "Running Extensions"));
    }
    getIcon() {
        return RuntimeExtensionsEditorIcon;
    }
    matches(other) {
        if (super.matches(other)) {
            return true;
        }
        return other instanceof RuntimeExtensionsInput;
    }
}

export { RuntimeExtensionsInput };
